/* eslint class-methods-use-this: 0 */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Glyphicon, Modal } from 'react-bootstrap';
import SessionStore from 'stores/SessionStore';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import ProTip from '../../../ui/ProTip';
import { PodUploader } from '../../documents/PodUploader';
import { PodDocumentsList } from '../../documents/PodDocumentsList';

const downloadFile = (url) => window.open(url);

class StopDocumentPreviewModal extends Component {
  static propTypes = {
    shipment: PropTypes.object.isRequired,
    stop: PropTypes.object.isRequired,
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onStopComplete: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      editMode: false,
      documents: [],
      files: [],
    };
  }

  handleComplete = async () => {
    if (!this.props.onStopComplete) {
      return;
    }

    const { shipment, stop } = this.props;
    const {
      timeline: {
        complete: {
          meta: { signatory },
        },
      },
    } = stop;

    const meta = {
      signatory,
      date: moment().toISOString(),
      value: '',
      name: '',
      reasonCode: '',
      reasonDescription: '',
    };
    const container = stop.equipments.find(
      (eq) => eq._equipmentType === 'container',
    );
    if (container) {
      meta.containerId = container.equipment_id;
    }

    const pods = this.state.files;
    if (pods.length) {
      meta.files = pods.map((document) => {
        return {
          key: document.key,
          id: document.id,
          bucket: document.bucket,
          type: 'shipmentdata',
        };
      });
    }
    this.props.onStopComplete(shipment, stop, [], meta);
    this.hide();
  };

  handleFileDownload = (files) => {
    files.forEach((file) => downloadFile(file.signedUrl));
  };

  handleShowEdit = () => this.setState({ editMode: true });
  handleCancelEdit = () => this.setState({ editMode: false });

  hide = () => {
    this.setState({
      documents: [],
      show: false,
    });

    this.props.onHide();
  };

  render() {
    if (!this.props.stop) return null;
    const { t } = this.props;

    const pocDocs = this.state.documents;

    const isAdmin = SessionStore.isAdmin();

    return (
      <Modal show={this.props.show} onHide={this.hide} style={{ top: '34%' }} enforceFocus={false}>
        <Modal.Header closeButton>
          <Modal.Title>{t('FILE_PREVIEW')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <h3 className="text-xl mt-0 mb-4">{t('PROOF_OF_COMPLETION')}</h3>
            <ProTip
              message={t('CLICK_IMAGE_TO_DOWNLOAD_FILE')}
              className={{ 'mb-4': true }}
            />
            {this.props.show && (
              <PodDocumentsList
                shipment={this.props.shipment}
                stop={this.props.stop}
                onInit={(documents) => {
                  this.setState({
                    documents,
                  });
                }}
              />
            )}
          </div>
          {this.state.editMode && (
            <PodUploader
              shipment={this.props.shipment}
              stop={this.props.stop}
              meta={this.props.stop.timeline?.complete?.meta}
              handleComplete={this.handleComplete}
              onUpload={(shipment, stop, type, uploadedFile) => {
                this.setState({
                  files: [uploadedFile],
                });
              }}
            />
          )}
          <div className="my-4 flex flex-wrap justify-between">
            <div>
              <label className="form-label block mb-2">{t('SIGNATORY')}</label>
              <span>{this.props.stop.signatory}</span>
            </div>
            <div className="preview-actions flex">
              <button
                type="button"
                className="button button-green mr-2"
                title={t('DOWNLOAD_POD')}
                onClick={() => this.handleFileDownload(pocDocs)}
              >
                <Glyphicon glyph="download" />
                <span className="ml-2">{titleize(t('DOWNLOAD'))}</span>
              </button>
              {isAdmin && !this.state.editMode && (
                <button
                  type="button"
                  title={t('REPLACE_POD')}
                  className="button button-hollow-green mr-2"
                  onClick={this.handleShowEdit}
                >
                  <Glyphicon glyph="upload" />
                  <span className="ml-2">{t('ATTACH_DOCUMENTS')}</span>
                </button>
              )}
              {isAdmin && this.state.editMode && (
                <button
                  type="button"
                  title={t('CANCEL_EDIT')}
                  className="button button-secondary"
                  onClick={this.handleCancelEdit}
                >
                  {t('CANCEL_EDIT')}
                </button>
              )}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default withTranslation()(StopDocumentPreviewModal);
